// To add colors, first look in the CarAdvise Digital Style Guide:
// https://caradvise.atlassian.net/wiki/spaces/PR/pages/21332001/Digital+Components?preview=/21332001/21200917/CarAdvise_DigitalComponents.pdf
export const BRIGHT_ORANGE = '#F8991D'
export const OFF_WHITE = '#F7F7F7'
export const RED = 'red'
export const GREEN = 'green'
export const BLUE = '#2185D0'
